import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Plot from 'react-plotly.js';
import {
  ManRadioButtonGroup,
  ManRadioButton,
  ManText
} from '@craft-design-system/core-components-react';
import Shimmer_graph from '../shimmer_graph';
import { useResetContext } from '../ResetContext';
import useGraphRadio from '../../utils/useGraphRadio';
import useSegmentedChartQuery from '../../utils/useSegmentedChartQuery';
import AverageDisplay from '../ride_analysis_kpi/Average_value';
import DownloadButtonComponent from '../DownloadButtonComponent';
import SegmentedControl from '../ride_analysis_kpi/SegmentedControl';
import { CustomTextDisplay } from '../AI';
import ifav from './ifav.png';
import Zoom from '../Zoom';

const System_charging_energy_session = ({ value }) => {
  const [system_charging_energy_session, set_system_charging_energy_session] = useState(null);
  const [downloadData, setDownloadData] = useState([]);
  const [radio_buttons_test, set_Radio_values] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [chartType, setChartType] = useState("Bar");
  const { resetdata } = useResetContext();
  const radio_query = useGraphRadio();
  const { fetchSegmentedChart } = useSegmentedChartQuery();
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const [avg_value, setavg_value] = useState(
    value?.chargingEnergySession?.[2]?.average || 0
  );

  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        <strong>Definition:</strong><br />
        This KPI displays the total charged energy during charging sessions. There is no differentiation among fast and normal charging on this KPI.<br /><br />
  
        <strong>Telematic raw data for this KPI:</strong><br />
        TBM3:<br />
        • chargedenergy<br />
        • energylevel<br />
        CM4:<br />
        • chargedenergy<br />
        • batchgdenergycbp<br />
        • energylevel<br />
        • energylevelcbp<br /><br />
  
        <strong>Time series data:</strong><br />
        If multiple vehicles are selected, average values are displayed.<br />
        Days without data are not taken into account for the calculation.
      </Popover.Body>
    </Popover>
  
  );

  const handleSelectChange1 = (event) => {
    set_Radio_values((prevValues) => ({
      ...prevValues,
      [event.detail.name]: event.detail.value,
    }));
  };

  useEffect(() => {
    if (radio_buttons_test) {
      setIsLoading(true);
      radio_query({
        vins_short: [value.vin_short],
        radio_value: radio_buttons_test,
        columnname: 'Charging Energy Session',   // ✅ correct column
        category: resetdata,
        chartType,
      })
        .then(data => {
          set_system_charging_energy_session(JSON.parse(data['jsonData'][0]));
          setavg_value(data['jsonData'][2]?.average || 0);
          setDownloadData(JSON.parse(data['jsonData'][3]));
        })
        .catch(err => {
          console.error("Error fetching Power Session data", err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [radio_buttons_test]);

  useEffect(() => {
    try {
      if (value?.chargingEnergySession?.[0]) {
        set_system_charging_energy_session(JSON.parse(value.chargingEnergySession[0]));
      }
      if (value?.chargingEnergySession?.[3]) {
        setDownloadData(JSON.parse(value.chargingEnergySession[3]));
      }
    } catch (error) {
      console.error("Error parsing JSON", error);
    }
  }, [value]);

  return (
    // <div style={{ padding: '20px', minHeight: '600px', display: 'flex', flexDirection: 'column', gap: '20px' }}>
    //   <div style={{ textAlign: 'center', position: 'relative' }}>
    //     <span className="card-title-text" style={{ fontSize: '20px', fontWeight: 'bold' }}>
    //     Session charged energy (total)
    //     </span>

    //     <div style={{ position: 'absolute', top: '-20px', right: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
    //       <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
    //         <img className="man-logovv1" src={ifav} alt="info" />
    //       </OverlayTrigger>

    //       <Zoom
    //           chartData={system_charging_energy_session?.data}
    //           chartLayout={system_charging_energy_session?.layout}
    //           chartTitle="Session charged energy (total)"
    //         />

    //       {downloadData && downloadData.length > 0 && (
    //         <DownloadButtonComponent
    //           data={downloadData}
    //           fileName={`system_charging_energy_session_${chartType.toLowerCase()}_${radio_buttons_test?.['Charging Power Session']?.toLowerCase() || 'daily'}.csv`}
    //         />
    //       )}
    //     </div>
    //   </div>
    <div style={{ padding: '16px' }}>
    {/* Title + Info */}
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '8px',
      gap: '8px'
    }}>
      <div style={{
        flex: 1,
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginLeft: '130px'
      }}>
        <ManText
          className="card-title-text"
          variant="component-l"
          as="span"
          size="l"
          style={{ lineHeight: 'normal' }}
        >
         Session charged energy (total)
        </ManText>
      </div>
      <div style={{
        flexShrink: 0,
        display: 'flex',
        alignItems: 'center',
        height: '100%',
        flexDirection: "row-reverse"
      }}>
        {/* <PopoverComponent
          id="charging_time"
          content={tooltipContent}
        /> */}
        <OverlayTrigger trigger="hover" placement="left" overlay={popover}>
          <img className="man-logovv1" src={ifav} alt="info" />
        </OverlayTrigger>
        <Zoom
          chartData={system_charging_energy_session?.data}
          chartLayout={system_charging_energy_session?.layout}
          chartTitle="Session charged energy (total)"
        />
        <DownloadButtonComponent
          data={downloadData}
          fileName={`system_charging_energy_session_${chartType.toLowerCase()}_${radio_buttons_test?.['Charging energy session']?.toLowerCase() || 'daily'}.xlsx`}
        />
      </div>
    </div>

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '20px', marginTop: '16px' }}>
        <div style={{ flexShrink: 0 }}>
          <AverageDisplay averages={avg_value} unit="kWh" />
        </div>
        <div style={{ flexGrow: 1, display: 'flex', justifyContent: 'center' ,marginRight:'20px'}}>
        <ManRadioButtonGroup
          name="Charging Energy Session"
          invalid="false"
          onManChange={handleSelectChange1}
          style={{ display: 'flex', gap: '20px' }}
        >
          <ManRadioButton name="Charging Energy Session" label="Daily" value="Daily" checked />
          <ManRadioButton name="Charging Energy Session" label="Monthly" value="Monthly" />
          <ManRadioButton name="Charging Energy Session" label="Yearly" value="Yearly" />
        </ManRadioButtonGroup>
        </div>
        {/* <div style={{ marginLeft: 'auto' }}>
          <SegmentedControl
            selected={chartType}
            onChange={(type) => setChartType(type)}
            options={["Bar"]}
          />
        </div> */}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end' }}>
      {isLoading ? (
          <Shimmer_graph />
        ) : (
          system_charging_energy_session && system_charging_energy_session.data?.length > 0 ? (
            <>
              <Plot
                data={system_charging_energy_session.data}
                layout={{
                  ...system_charging_energy_session.layout,
                  margin: { t: 10, r: 10, l: 10, b: 160 },
                  xaxis: {
                    ...system_charging_energy_session.layout?.xaxis,
                    rangeslider: { visible: false },
                  },
                  autosize: true,
                  responsive: true,
                }}
                useResizeHandler={true}
                style={{ width: '100%', height: '100%' }}
              />
            </>
          ) : (
            <div style={{ textAlign: 'center', color: 'gray', fontSize: '16px', marginTop: '40px' }}>
              No data available for current filter
            </div>
          )
        )}
      </div>
    </div>
  );
};

System_charging_energy_session.propTypes = {
  value: PropTypes.shape({
    vin_short: PropTypes.string.isRequired,
    chargingEnergySession: PropTypes.array.isRequired,   // ✅ correct prop
  }).isRequired,
};

export default System_charging_energy_session;
